import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetJit =
  ({ callback, page, rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link =
        UrlApi.join_our_team.get + `?limit=${rowsPerPage}&page=${page}`;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteJOT =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      console.log({ id_DeleteJOT: id });
      let link = UrlApi.join_our_team.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageJIT =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      console.log({ values_manageJIT: values });
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
        console.log("2");
      }
      if (CheckDataIfExit(values?.complete_name)) {
        bodyFormData.append("complete_name", values?.complete_name?.trim());
      }
      if (CheckDataIfExit(values?.email)) {
        bodyFormData.append("email", values?.email?.trim());
      }
      if (CheckDataIfExit(values?.phone)) {
        bodyFormData.append("phone", values?.phone);
      }
      if (CheckDataIfExit(values?.message)) {
        bodyFormData.append("message", values?.message?.trim());
      }

      if (
        values?.cv &&
        values?.cv != null &&
        values?.cv != undefined &&
        CheckImageIsFile({ data: values?.cv, IsBoolean: true })
      ) {
        bodyFormData.append("cv", values?.cv);
      } else if (editMode && !values?.cv) {
        bodyFormData.append("cv", "");
      }
      console.log({ bodyFormDatabodyFormData: bodyFormData });
      console.log("3");
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.join_our_team.edit}/${paramID}`
          : UrlApi.join_our_team.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      console.log("4");
      callback(response);
    } catch (err) {
      console.log("5");
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditJit =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.join_our_team.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
